<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { ModelInfoManager } from "../ModelInfoManager";

    export let manager: ModelInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
</script>

<div class="card-body p-4">
    <h3 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.about.title`)}
    </h3>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.p1.part1`)}
        <a href="https://mobilit.belgium.be/" target="_blank">
            {$_(`${$modelTranslationKeyStore}.info.about.p1.part2`)}
        </a>.
    </p>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.about.p3.part1`)}
        <a
            href="https://www.anyways.eu/blog/2022-06-14-simulating-commutes"
            target="_blank">
            {$_(`${$modelTranslationKeyStore}.info.about.p3.part2`)}</a>
    </p>
    <h3 class="mb-1">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.title`)}
    </h3>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part1`)}
        <a
            href="https://docs.anyways.eu/vehicle-profiles/bicycle.commute"
            target="_blank">{$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part2`)}</a>
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p1.part3`)}
    </p>
    <p class="mb-1 small">
        {$_(`${$modelTranslationKeyStore}.info.assumptions.p2`)}
    </p>
</div>
